import { CssPropertyType } from '@wix/ambassador-devcenter-components-v1-component/types';
import { GlobalDesignAction } from '../types';
import { groupByGroupDefinitions } from '../common/grouping/defaultGroupingStrategy';
import { FontStyleValue } from '../common/lobby/types';
import compareColors from '../common/grouping/compare/compareColors';
import { MergingStrategyConfig } from '../common/grouping/types';
import defaultValueMergingStrategy from '../common/grouping/defaultValueMergingStrategy';
import { isEqual } from 'lodash';

export const textGrouping: GlobalDesignAction<'textStyles'>['grouping'] = {
  getGroupingStrategy: (editorPointer, getHost) => {
    return () => {
      return groupByGroupDefinitions(editorPointer, 'textStyles', getHost);
    };
  },

  applyValueMergingStrategy: (stylesGroups) => {
    const config: MergingStrategyConfig<'textStyles'> = {
      allowSubsets: false,
      valueComparator: {
        [CssPropertyType.color]: compareColors,
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.fontFamily]: (
          value1: FontStyleValue['fontFamily'],
          value2: FontStyleValue['fontFamily'],
        ): boolean => {
          return (
            // @ts-expect-error - TODO: ds-types-bump
            value1?.type === value2?.type &&
            // @ts-expect-error - TODO: ds-types-bump
            isEqual(value1?.value, value2?.value)
          );
        },
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.fontSize]: (
          value1: FontStyleValue['fontSize'],
          value2: FontStyleValue['fontSize'],
        ): boolean => {
          return isEqual(value1, value2);
        },
        // @ts-expect-error - TODO: ds-types-bump
        [CssPropertyType.fontWeight](
          value1: FontStyleValue['fontWeight'],
          value2: FontStyleValue['fontWeight'],
        ): boolean {
          return isEqual(value1, value2);
        },
      },
    };

    return defaultValueMergingStrategy<'textStyles'>(stylesGroups, config);
  },
};
